import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import withMobileDialog from '@material-ui/core/withMobileDialog'

import Typography from '@material-ui/core/Typography'
import FormGroup from '@material-ui/core/FormGroup'
import FormControl from '@material-ui/core/FormControl'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import TextField from '@material-ui/core/TextField'
//import Input from '@material-ui/core/Input'
import Checkbox from '@material-ui/core/Checkbox'
import Switch from '@material-ui/core/Switch'
import Grid from '@material-ui/core/Grid'

import InputLabel from '@material-ui/core/InputLabel'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'

import { connect } from 'react-redux'

import { handleSaveOffice } from '../../actions/offices'
import { savePackets } from '../../utils/api'
//import { officeStatuses } from '../../utils/_DATA'
import { packetPriceCurrencies, packetPriceTypes, packetDepositOptions } from '../../utils/_DATA'
import t from '../../utils/lang/office'

const styles = theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    minWidth: '300px',
    maxWidth: '400px',
  },
  formControl: {
    margin: '0 0 10px',
    width: '100%'
  },
  currencyFormControl: {
    marginTop: '16px'
  },
  sectionTitle: {
    width: '100%',
    marginTop: '15px',
    marginBottom: '10px',
    fontWeight: '500'
  },
  packetName: {
    fontSize: '14px'
  }
});

class PricingDialog extends Component {
  state = {
    packets: null,
  }

  componentDidMount() {
    const { data } = this.props

    //console.log(data)

    this.setState(() => ({
      packets: Object.values(data)
    }))
  }

  handleChangePacketValue = (e, index) => {
    const { packets } = this.state
    const value = e.target.value

    const newPackets = packets
    newPackets[index].form.value = value

    this.setState(() => ({
      packets: newPackets
    }))
  }

  handleChangePacketCurrency = (e, index) => {
    const { packets } = this.state
    const value = e.target.value

    const newPackets = packets
    newPackets[index].form.currency = value

    this.setState(() => ({
      packets: newPackets
    }))
  }

  handleChangePacketFeeType = (e, index) => {
    const { packets } = this.state
    const value = e.target.value

    const newPackets = packets
    newPackets[index].form.feeType = value

    this.setState(() => ({
      packets: newPackets
    }))
  }

  handleChangePacketDepositType = (e, index) => {
    const { packets } = this.state
    const value = e.target.value

    const newPackets = packets
    newPackets[index].form.depositType = value

    this.setState(() => ({
      packets: newPackets
    }))
  }

  handleChangePacketNote = (e, index) => {
    const { packets } = this.state
    const value = e.target.value

    const newPackets = packets
    newPackets[index].form.note = value

    this.setState(() => ({
      packets: newPackets
    }))
  }

  handleSaveData = e => {
    const { officeId, handleClose, handleRefreshPackets, dispatch } = this.props
    const packetData = this.state.packets

    savePackets(officeId, packetData)

    handleRefreshPackets()
    handleClose()
  }

  render() {
    const { fullScreen, open, handleClose, classes } = this.props
    //const { packets } = this.state
    const packets = this.state.packets !== null ? this.state.packets : this.props.data
    const guidePricesIndexes = [0,1,2,3,4]
    const additionalCostsIndexes = [5,6,7,8,9,10,11]

    const lang = 'en'

    return (
      <div>
        <Dialog
          fullScreen={fullScreen}
          open={open}
          onClose={handleClose}
          aria-labelledby="responsive-dialog-title"
        >
          <DialogTitle id="responsive-dialog-title">Edit packet</DialogTitle>
          <DialogContent>
            <form className={classes.root}>
              <Typography variant="headline" className={classes.sectionTitle}>
                {t[lang].guidePricesHeader}
              </Typography>

              {guidePricesIndexes.map((index) => (
                <Grid key={index} container>
                  <Grid item xs={9}>
                    <FormControl className={classes.formControl}>
                      <TextField
                        id={`packetValue[${index}]`}
                        label={packets[index].name}
                        value={packets[index].form.value}
                        type="number"
                        onChange={e => this.handleChangePacketValue(e, index)}
                      />
                    </FormControl>
                  </Grid>

                  <Grid item xs={3}>
                    <FormControl className={classes.formControl}>
                      <InputLabel htmlFor="price1hCurrency">{t[lang].currency}</InputLabel>
                      <Select
                        id={`packetCurrency[${index}]`}
                        value={packets[index].form.currency}
                        onChange={e => this.handleChangePacketCurrency(e, index)}
                        className={classes.currencyFormControl}
                      >
                        {packetPriceCurrencies.map((option) => (
                          <MenuItem key={option.id} value={option.id}>{option.title}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
              ))}

              <Typography variant="headline" className={classes.sectionTitle}>
                {t[lang].additionalCostsHeader}
              </Typography>

              <FormControl className={classes.formControl}>
                <InputLabel htmlFor="packetType[5]">{packets[5].name}</InputLabel>
                <Select
                  id="packetType[5]"
                  value={packets[5].form.depositType}
                  onChange={e => this.handleChangePacketDepositType(e, 5)}
                >
                  {packetDepositOptions.map((option) => (
                    <MenuItem key={option.id} value={option.id}>{option.title}</MenuItem>
                  ))}
                </Select>
              </FormControl>

              {additionalCostsIndexes.map((index) => (
                <Grid key={index} container>
                  {[6,7,8].includes(index) && (<Fragment>
                    <Grid item xs={index === 8 ? 9 : 6}>
                      <FormControl className={classes.formControl}>
                        <TextField
                          id={`packetValue[${index}]`}
                          label={packets[index].name}
                          value={packets[index].form.value}
                          type="number"
                          onChange={e => this.handleChangePacketValue(e, index)}
                        />
                      </FormControl>
                    </Grid>

                    <Grid item xs={3}>
                      <FormControl className={classes.formControl}>
                        <InputLabel htmlFor={`packetCurrency[${index}]`}>{t[lang].currency}</InputLabel>
                        <Select
                          id={`packetCurrency[${index}]`}
                          value={packets[index].form.currency}
                          onChange={e => this.handleChangePacketCurrency(e, index)}
                          className={classes.currencyFormControl}
                        >
                          {packetPriceCurrencies.map((option) => (
                            <MenuItem key={option.id} value={option.id}>{option.title}</MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>

                    {[6,7].includes(index) && (<Grid item xs={3}>
                      <FormControl className={classes.formControl}>
                        <InputLabel htmlFor={`packetType[${index}]`}>{t[lang].feeType}</InputLabel>
                        <Select
                          id={`packetType[${index}]`}
                          value={packets[index].form.feeType}
                          onChange={e => this.handleChangePacketFeeType(e, index)}
                          className={classes.currencyFormControl}
                        >
                          {packetPriceTypes.map((option) => (
                            <MenuItem key={option.id} value={option.id}>{option.title}</MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>)}

                  </Fragment>)}

                  {[9,10,11].includes(index) && (<FormControl className={classes.formControl}>
                    <TextField
                      id={`packetValue[${index}]`}
                      label={packets[index].name}
                      value={packets[index].form.note}
                      multiline
                      onChange={e => this.handleChangePacketNote(e, index)}
                    />
                  </FormControl>)}

                </Grid>
              ))}
            </form>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              Cancel
            </Button>
            <Button onClick={this.handleSaveData} color="primary" autoFocus>
              Save
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

PricingDialog.propTypes = {
  fullScreen: PropTypes.bool.isRequired,
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  officeId: PropTypes.string.isRequired,
  data: PropTypes.array.isRequired
};

function mapStateToProps ({ authedUser }) {
  return {
    userId: authedUser.id
  }
}

export default connect(mapStateToProps)(withStyles(styles)(withMobileDialog()(PricingDialog)))


// WEBPACK FOOTER //
// ./src/components/Offices/PricingDialog.js